import config from "appConfig";
import { LayoutComponents } from "packages/lesson/dist/@types";

const components: LayoutComponents = [
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/27/principle/matelys-reference-material.svg`,
          },
        },
        styles: {
          padding: "3%",
        },
      },
    },
  ],
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/27/principle/fibrous-material-1.svg`,
          },
        },
        styles: {
          padding: "3%",
        },
      },
    },
  ],
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/27/principle/fibrous-material-2.svg`,
          },
        },
        styles: {
          padding: "3%",
        },
      },
    },
  ],
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/27/principle/fibrous-material-3.svg`,
          },
        },
        styles: {
          padding: "3%",
        },
      },
    },
  ],
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/27/principle/fibrous-material-4.svg`,
          },
        },
        styles: {
          padding: "3%",
        },
      },
    },
  ],
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/27/principle/foam-1.svg`,
          },
        },
        styles: {
          padding: "3%",
        },
      },
    },
  ],
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/27/principle/foam-2.svg`,
          },
        },
        styles: {
          padding: "3%",
        },
      },
    },
  ],
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/27/principle/foam-3.svg`,
          },
        },
        styles: {
          padding: "3%",
        },
      },
    },
  ],
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/27/principle/atypical-foam-1.svg`,
          },
        },
        styles: {
          padding: "3%",
        },
      },
    },
  ],
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/27/principle/atypical-foam-2.svg`,
          },
        },
        styles: {
          padding: "3%",
        },
      },
    },
  ],
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/27/principle/atypical-foam-3.svg`,
          },
        },
        styles: {
          padding: "3%",
        },
      },
    },
  ],
];

export default components;
